/*
 * Transparency data — the single source of truth for the public
 * transparency page. Update ONLY when the books support the change
 * (see AGENTS.md Section 2: never fabricate results).
 *
 * All figures in USD. `asOf` is shown publicly next to the numbers.
 */

const transparency = {
  asOf: "September 7, 2026",
  fiscalYear: 2026,
  totals: {
    contributions: 18420,
    used: 12760,
    // available is computed, never hard-coded, so it can't drift
  },
  breakdown: [
    { category: "IT Equipment", amount: 5240, icon: "🖥️" },
    { category: "Community IT Services", amount: 2850, icon: "🛠️" },
    { category: "Education & Training", amount: 2100, icon: "🎓" },
    { category: "Infrastructure / Hosting", amount: 1470, icon: "🌐" },
    { category: "Administration", amount: 1100, icon: "📋" },
  ],
};

// sanity: the breakdown must account for the used total (guard against typos)
const breakdownSum = transparency.breakdown.reduce((s, b) => s + b.amount, 0);
if (breakdownSum !== transparency.totals.used) {
  // surface loudly in development rather than publishing mismatched math
  console.warn(
    `[transparency] breakdown sum (${breakdownSum}) does not equal used (${transparency.totals.used})`
  );
}

export default transparency;
